import { handleAction } from 'redux-actions';
import { receiveFixtures } from './actions';

export const fixtures = handleAction(
  receiveFixtures,
  {
    next(state, { payload }) {
      return payload;
    }
  },
  []
);



// WEBPACK FOOTER //
// ./src/modules/fixture/reducers.js